import * as R from 'ramda';

export default function ScheduledReportsController(
  $q,
  $scope,
  $rootScope,
  $filter,
  userService,
  reportsDataService,
) {
  const vm = this;

  vm.reportInstanceTypes = [];
  vm.hasReportInstanceTypes = false;

  vm.filteredReportInstanceTypes = [];
  vm.hasFilteredReportInstanceTypes = false;
  
  vm.reportCategories = [];
  vm.reportNames = [];
  vm.reportOwnerNames = [];

  vm.showFilters = true;  

  vm.filter = {
    category: -1,
    reportName: -1,
    hasSchedules: false,
  };

  vm.handleClearFilters = _handleClearFilters;
  vm.handleFilterChange = _handleFilterChange;


  _activate();

  /** ********************************************
   * Event Handlers
   */

  $scope.$on('reports.scheduledReports.reportTypeEmpty', (event, reportType) => {
    _handleDeletedReportType(reportType);
  });


  /** ********************************************
   * Private Functions
   */

  function _activate() {
    vm.appIsLoaded = false;
    vm.showFilters = true;
   
    const promises = [
      _loadCustomerId(),
      reportsDataService.getScheduledReportSummary(1)
    ];

    return $q.all(promises).then((response) => {
      
      vm.reportInstanceTypes = response[1].data.result;
      vm.hasReportInstanceTypes = vm.reportInstanceTypes.length > 0;

      _extractReportCategories();
      _extractReportNames();

      _handleFilterChange();

      vm.appIsLoaded = true;
    });
  }
  
    function _handleDeletedReportType(reportType) {
      _remove(vm.filteredReportInstanceTypes);
      _remove(vm.reportInstanceTypes);
  
      function _remove(collection) {
        const pos = collection.findIndex(item => item.uniqueId === reportType.uniqueId);
        if (pos === -1) {
          return; // Can't find the item
        }
        collection.splice(pos, 1);
      }
      
      _extractReportCategories();
      _extractReportNames();
  
      _handleFilterChange();
    }
    
    function _loadCustomerId() {
      return userService.getUser().then((user) => {
        vm.customerId = user.customerId;
      });
    }
  
    function _extractReportCategories() {
      const _categories = [];
      const _categoryIds = [];
  
      R.forEach((reportInstanceType) => {
        let _found = false;
        const _categoryId = reportInstanceType.groupId;
        const _categoryName = reportInstanceType.groupName;
  
        R.forEach((categoryId) => {        
          if (categoryId === _categoryId) {
            _found = true;
          };
        }, _categoryIds);
  
        if (!_found) {
          const category = {
            id: _categoryId,
            name: _categoryName,
          };
          _categories.push(category);
          _categoryIds.push(_categoryId);
        }
      }, vm.reportInstanceTypes);
  
      vm.reportCategories = R.sortBy(R.prop('name'), _categories);
    }
  
    function _extractReportNames() {
      const _reportNames = [];
      const _reportIds = [];
  
      R.forEach((reportInstanceType) => {
        let _found = false;
        const _reportId = reportInstanceType.reportId;
        const _reportName = reportInstanceType.reportName;
  
        R.forEach((reportId) => {        
          if (reportId === _reportId) {
            _found = true;
          };
        }, _reportIds);
  
        if (!_found) {
          const reportName = {
            id: _reportId,
            name: _reportName,
          };
          _reportNames.push(reportName);
          _reportIds.push(_reportId);
        }
      }, vm.reportInstanceTypes);
  
      vm.reportNames = R.sortBy(R.prop('name'), _reportNames);
    }
  
    function _handleClearFilters() {
      vm.filter.category = -1;
      vm.filter.reportName = -1;
      vm.filter.hasSchedules = false;
  
      _handleFilterChange();
    } 
  
    function _handleFilterChange() {
      let _filteredReportInstanceTypes = vm.reportInstanceTypes;
  
      if (vm.filter.category !== -1) {
        _filteredReportInstanceTypes = $filter('filter')(_filteredReportInstanceTypes, { groupId: vm.filter.category });
      }
  
      if (vm.filter.reportName !== -1) {
        _filteredReportInstanceTypes = $filter('filter')(_filteredReportInstanceTypes, { reportName: vm.filter.reportName });
      }
  
      if (vm.filter.hasSchedules !== -1) {
        if (vm.filter.hasSchedules) {
          const _frpits = [];

          R.forEach((filteredReportInstanceType) => {          
            if (filteredReportInstanceType.numberOfSchedules > 0) {
              _frpits.push(filteredReportInstanceType);
            }
          }, _filteredReportInstanceTypes);
    
          _filteredReportInstanceTypes = _frpits;  
        }    
      } 
  
      vm.filteredReportInstanceTypes = _filteredReportInstanceTypes;
      vm.hasFilteredReportInstanceTypes = vm.filteredReportInstanceTypes.length > 0;
    }
}

ScheduledReportsController.$inject = [
  '$q',
  '$scope',
  '$rootScope',
  '$filter',
  'userService',
  'reportsDataService',
];
